<template>
    <main-content v-if="$can('manage', 'gateway')">
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#corporates" role="tab" aria-selected="false">
                                {{ $t('label.generate_bill_list') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#general-settings" role="tab" aria-selected="false">
                                {{ $t('label.bill_generate_general_settings') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
                <kt-panel-header-actions :style="headerAction">
                    <router-link :to="{ name: 'add_corporate' }" class="btn btn-success">
                        {{ $t('label.add_corporate') + " " }}
                    </router-link>
                </kt-panel-header-actions>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div class="tab-pane active" id="corporates">
                      <corporates></corporates>
                    </div>
                    <div class="tab-pane" id="general-settings">
                        <GeneralBillSettings></GeneralBillSettings>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import corporates from './components/corporate-list'
import GeneralBillSettings from './components/general-bill-settings'


export default { //todo
    components: {
mainContent,corporates,GeneralBillSettings
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>

</style>